import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

// Phase 38-02: lazy-fetched busy-dates for a single equipment item in a date
// range. Enabled only when itemId !== '' so the JobDetailPanel +Add form
// doesn't fire it on initial render (before planner picks an item). Mirrors
// useVehicleBusyDates pattern from 38-01 exactly.
export function useEquipmentBusyDates(itemId: string, from: string, to: string) {
  return useQuery({
    queryKey: ['equipment', itemId, 'busy-dates', from, to],
    queryFn: () => api.equipment.busyDates(itemId, from, to),
    enabled: itemId !== '',
    staleTime: 5 * 60 * 1000,
  });
}
